import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { IModuleUserDateRangeFilters } from 'app/library/module-user/interfaces/module-user-date-range-filters.interface';
import { ModuleUser } from 'app/library/module-user/models/module-user.model';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import { FetchModuleParticipants, FetchModuleParticipantsFailure, FetchModuleParticipantsSuccess } from '../actions';
import { ModuleParticipantsState } from '../models/module-participants.state';

@Injectable()
export class ModuleParticipantsService {
    @Select(ModuleParticipantsState.getEntities)
    moduleParticipant$: Observable<ModuleUser[]>;

    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    getModuleParticipants(): ModuleUser[] {
        return this._store.selectSnapshot(ModuleParticipantsState.getEntities);
    }

    async fetchModuleParticipants(
        moduleId: string,
        search?: string,
        sortBy?: string,
        sortOrder?: string,
        pageSize?: number,
        pageNumber?: number,
        withoutCertificate?: boolean,
        selectedCertificateIds?: string[],
        selectedProgressStatuses?: string[],
        dateRangeFilters?: IModuleUserDateRangeFilters
    ): Promise<boolean> {
        this._store.dispatch(
            new FetchModuleParticipants({
                moduleId,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber,
                withoutCertificate,
                selectedCertificateIds,
                selectedProgressStatuses,
                dateRangeFilters,
            })
        );

        return await this._actionHelper.race(FetchModuleParticipantsSuccess, FetchModuleParticipantsFailure).toPromise();
    }
}
